var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliceCapSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 75,
    viewBox: "0 0 76 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1074)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1074)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0661 3.9C38.7297 3.75403 38.3668 3.67871 38.0001 3.67871C37.6333 3.67871 37.2705 3.75403 36.934 3.9L2.11256 18.9911C1.63413 19.1992 1.22688 19.5425 0.94085 19.9788C0.654815 20.4152 0.502441 20.9256 0.502441 21.4473C0.502441 21.9691 0.654815 22.4794 0.94085 22.9158C1.22688 23.3521 1.63413 23.6955 2.11256 23.9036L6.89649 25.9768V55.9286C5.50327 56.5447 4.36413 57.6209 3.66998 58.9769C2.97582 60.333 2.76882 61.8864 3.08367 63.3769C3.39852 64.8673 4.21609 66.2043 5.39937 67.1637C6.58264 68.1232 8.05973 68.6468 9.5831 68.6468C11.1065 68.6468 12.5836 68.1232 13.7668 67.1637C14.9501 66.2043 15.7677 64.8673 16.0825 63.3769C16.3974 61.8864 16.1904 60.333 15.4962 58.9769C14.8021 57.6209 13.6629 56.5447 12.2697 55.9286V28.3018L36.9286 38.9893C37.2651 39.1353 37.6279 39.2106 37.9947 39.2106C38.3615 39.2106 38.7243 39.1353 39.0608 38.9893L73.8822 23.9036C74.3606 23.6955 74.7679 23.3521 75.0539 22.9158C75.34 22.4794 75.4923 21.9691 75.4923 21.4473C75.4923 20.9256 75.34 20.4152 75.0539 19.9788C74.7679 19.5425 74.3606 19.1992 73.8822 18.9911L39.0661 3.9ZM16.3358 50.1054L16.309 37.3554L34.2715 45.1339C35.4476 45.6433 36.7157 45.9061 37.9974 45.9061C39.2791 45.9061 40.5472 45.6433 41.7233 45.1339L59.6911 37.35V50.1C59.6931 50.6857 59.503 51.2558 59.1501 51.7232L57.0126 50.1L59.1447 51.7232V51.7339L59.1286 51.7446L59.1019 51.7821L59.0215 51.8839L58.7483 52.2054C58.4315 52.561 58.099 52.9024 57.7519 53.2286C56.565 54.3476 55.2652 55.3404 53.8733 56.1911C50.3911 58.3232 45.1572 60.3911 38.0001 60.3911C30.8429 60.3911 25.609 58.3232 22.1429 56.1857C20.7491 55.34 19.4489 54.3488 18.2644 53.2286C17.8174 52.8032 17.3952 52.3525 17.0001 51.8786L16.9197 51.7714L16.8929 51.7393L16.8822 51.7286C16.8769 51.7232 16.8769 51.7179 19.0144 50.1L16.8715 51.7179C16.5238 51.2542 16.3358 50.6849 16.3358 50.1054Z",
    fill: "url(#paint0_linear_1_1074)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1074",
    x: -3.49756,
    y: 3.67871,
    width: 82.9897,
    height: 72.968,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1074"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1074",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1074",
    x1: 37.9974,
    y1: 3.67871,
    x2: 37.9974,
    y2: 68.6468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20AC95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#018563"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceCapSolid);
export default __webpack_public_path__ + "static/media/PoliceCapSolid.bfe35f36d9b628be572883f83d3f77ac.svg";
export { ForwardRef as ReactComponent };